export default __webpack_public_path__ + "static/media/hand-scis-blk.43352a88.svg";